import type { Template as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Template = {
  id: number;
  templateName: string;
};

export const fromGql = (item: GQLItem): Template =>
  take<Template, GQLItem>(item, 'id', 'templateName');
